/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_NothingInputs */



/**
* | output |
* | --- |
* | "The project already matches this checkpoint." |
*
* @param {Assistant_Restore_NothingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_nothing = /** @type {((inputs?: Assistant_Restore_NothingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_NothingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le projet correspond déjà à ce point de contrôle.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Projekt erfüllt diesen Prüfpunkt bereits.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il progetto corrisponde già a questo punto di controllo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект уже соответствует этому контрольному пункту.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El proyecto ya coincide con este punto de control.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("该项目已达到此检查点。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプロジェクトは既にこのチェックポイントを満たしています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह प्रोजेक्ट पहले से ही इस मानदंड को पूरा करता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O projeto já atende a este ponto de verificação.")
	return /** @type {LocalizedString} */ ("The project already matches this checkpoint.")
});